import { Client } from "../interfaces/clientConfig";

const {
  REACT_APP_AUTH_API_BASE_URL,
  REACT_APP_CONFIG_API_BASE_URL,
  REACT_APP_ENV_NAME,
  REACT_APP_NOTIFICATIONS_API_BASE_URL,
  REACT_APP_S3_BASE_URL,
  REACT_APP_SENTRY_DSN,
  REACT_APP_SENTRY_SAMPLE_RATE,
  REACT_APP_CLIENT_NAME,
  REACT_APP_AVENIDA_EVENT_ACTIVE,
  REACT_APP_ORDERS_V2_ENABLED,
} = process.env;
const config = {
  AUTH_API_BASE_URL:
    REACT_APP_AUTH_API_BASE_URL || "https://api-dev.coatiapp.com/auth",
  CONFIG_API_BASE_URL:
    REACT_APP_CONFIG_API_BASE_URL || "https://api-dev.coatiapp.com/config",
  REACT_APP_NOTIFICATIONS_API_BASE_URL:
    REACT_APP_NOTIFICATIONS_API_BASE_URL as string,
  S3_BASE_URL: REACT_APP_S3_BASE_URL,
  ENV_NAME: REACT_APP_ENV_NAME,
  SENTRY_DSN: REACT_APP_SENTRY_DSN,
  SENTRY_SAMPLE_RATE: Number(REACT_APP_SENTRY_SAMPLE_RATE),
  REACT_APP_CLIENT_NAME: REACT_APP_CLIENT_NAME?.toLocaleLowerCase() as
    | Client
    | undefined,
  AVENIDA_EVENT_ACTIVE: REACT_APP_AVENIDA_EVENT_ACTIVE === "true",
  ORDERS_V2_ENABLED: REACT_APP_ORDERS_V2_ENABLED === "true",
};

export default config;
